export class TimeSeriesColumnLabels {
  constructor(
    public headerLabel: string[],
    public footerLabel: string,
    public subHeaderLabel: string | null,
    public isStartOfPeriodGroup?: boolean
  ) { }
}
